import React from 'react';
import { MenuItem } from '@mui/material';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { DeleteAllCookies } from '../Components/CommonFunctions/CommonFunctions'; // Adjust the import based on your project structure
import { localEndPoint } from './ServerCall/EnvironmentVariables';
import { fromRoute, navigatetTo } from './CommonFunctions/aliases';

interface LogoutMenuItemProps {
  handleMenuClose: () => void;
  from: string;
  saveAndNavigateTo?: (path: string) => void;
}

const LogoutMenuItem: React.FC<LogoutMenuItemProps> = ({
  handleMenuClose,
  from,
  saveAndNavigateTo,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    handleMenuClose();
    // To handle logout
    sessionStorage.setItem('isLoggingOut', 'true');

    if (from === fromRoute.dataViewer && typeof saveAndNavigateTo === 'function') {
      saveAndNavigateTo(navigatetTo.login);
    } else {
      if (window.location.protocol === 'https:') {
        let authToken: any = Cookies.get('authToken');
        let decodedToken: any = null;
        if (authToken) {
          decodedToken = jwtDecode(authToken);
          sessionStorage.setItem('accessType', decodedToken?.access); // Store the access type of the user for navigation to login page
        }

        DeleteAllCookies();
        Cookies.remove('authToken');
        Cookies.remove('authToken', {
          path: '/',
          domain: new URL(localEndPoint || '').hostname,
        });

        localStorage.clear();

        localStorage.setItem('isLoggingOut', 'true'); // Prevent default popup on navigation
        window.history.pushState(null, '', '/');
        window.location.href = `${localEndPoint}auth/logout`;
        window.location.reload(); // Reload the page for useEffect hook
        // commented code might be useful if on logout we want to redirect to different logout urls based on access type
        // if (authToken && decodedToken?.access === 'community') {
        //   localStorage.setItem('isLoggingOut', 'true'); // Prevent default popup on navigation
        //   window.history.pushState(null, '', '/');
        //   window.location.href = `${localEndPoint}auth/logout`;
        //   window.location.reload(); // Reload the page for useEffect hook
        // } else {
        //   localStorage.setItem('isLoggingOut', 'true'); // Prevent default popup on navigation
        //   window.history.pushState(null, '', '/');
        //   window.location.href = `${localEndPoint}auth/logout`;
        //   window.location.reload(); // Reload the page for useEffect hook
        // }
      } else {
        DeleteAllCookies();
        Cookies.remove('authToken');
        Cookies.remove('authToken', {
          path: '/',
          domain: new URL(localEndPoint || '').hostname,
        });

        localStorage.clear();
        localStorage.setItem('isLoggingOut', 'true'); // Prevent default popup on navigation
        window.history.pushState(null, '', '/');
        window.location.href = `${localEndPoint}auth/logout`;
        window.location.reload(); // Reload the page for useEffect hook
      }
      DeleteAllCookies();
      Cookies.remove('authToken');
      Cookies.remove('authToken', {
        path: '/',
        domain: new URL(localEndPoint || '').hostname,
      });
      localStorage.clear();
    }
  };

  return (
    <MenuItem onClick={handleClick} style={{ height: '35px', alignItems: 'center' }}>
      <div
        className="menuLink"
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <img
          src="/logout.png"
          alt="Logout"
          style={{
            marginRight: '8px',
            transform: 'translateY(1px)',
            width: '17px',
            height: '14px',
          }}
        />
        <span>Logout</span>
      </div>
    </MenuItem>
  );
};

export default LogoutMenuItem;
